/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { forum_filebase_full } from '../models/forum_filebase_full';
import type { forum_fire_entry_full } from '../models/forum_fire_entry_full';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ForumService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get all entries where a file can be added
   * @returns forum_fire_entry_full successful
   * @throws ApiError
   */
  public gellAllFileEntries({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<forum_fire_entry_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/forum/file_entries',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Add a file to the forum
   * @returns forum_filebase_full successful
   * @throws ApiError
   */
  public createFilebase({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<forum_filebase_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/forum/filebases',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get a filebase
   * @returns forum_filebase_full successful
   * @throws ApiError
   */
  public getFilebase({
    locale,
    filebaseId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Filebase identifier
     */
    filebaseId: string;
  }): CancelablePromise<forum_filebase_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/forum/filebases/{filebase_id}',
      path: {
        locale: locale,
        filebase_id: filebaseId,
      },
    });
  }
}
